import { Checkbox, withStyles } from "@material-ui/core";
import React from "react";
import { fontColor } from "../../../assets/jss/appHealth.style";
import { inject } from "mobx-react";
import { observer } from "mobx-react-lite";

const CurvaPeriodos = observer(({ classes, exameStore }) => {
  const handleChangeCheckbox = (tipo) => {
    const raw = exameStore.exame?.amostras;

    const amostras = Array.isArray(raw) ? raw : raw ? [raw] : [];

    const existe =
      amostras.length > 0 && amostras?.some((a) => a.descricao === tipo);

    if (existe) {
      exameStore.exame.amostras = amostras.filter((a) => a.descricao !== tipo);
    } else {
      exameStore.exame.amostras = [
        ...amostras,
        {
          descricao: tipo,
          material: exameStore.exame?.material?.codigo,
          exames: [{ codigo: exameStore.exame?.tipoExame?.codigo }],
        },
      ];
    }
  };

  const periodos =
    exameStore?.exame?.amostras?.length > 0
      ? exameStore?.exame?.amostras?.flatMap((item) => item.descricao)
      : [];

  return (
    <div className={classes.content}>
      <div className={classes.span}>Periodo de curvas :</div>
      <div>
        <div className={classes.row}>
          Manhã
          <Checkbox
            id="pac-cvp-chk-man"
            key={"manha"}
            color={"primary"}
            onChange={(e) => handleChangeCheckbox("manha")}
            checked={periodos?.includes("manha")}
          />
        </div>
        <div className={classes.row}>
          Tarde
          <Checkbox
            id="pac-cvp-chk-tar"
            key={"tarde"}
            color={"primary"}
            onChange={(e) => handleChangeCheckbox("tarde")}
            checked={periodos?.includes("tarde")}
          />
        </div>
        <div className={classes.row}>
          Noite
          <Checkbox
            id="pac-cvp-chk-noi"
            key={"noite"}
            color={"primary"}
            onChange={(e) => handleChangeCheckbox("noite")}
            checked={periodos?.includes("noite")}
          />
        </div>
        <div className={classes.spanAviso}>
          * Selecione pelo menos dois períodos
        </div>
      </div>
    </div>
  );
});

const styles = {
  content: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  row: {
    gap: "8px",
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end",
    padding: "5px",
    color: "#505050",
    fontSize: "14px",
  },
  span: {
    color: fontColor,
    fontSize: "16px",
    fontWeight: "bold",
    marginBottom: "5px",
  },
  spanAviso: {
    color: "#868686",
    fontSize: "12px",
    marginTop: "5px",
  },
};

const CurvaPeriodosWithStyles = withStyles(styles)(CurvaPeriodos);

export default inject("exameStore")(CurvaPeriodosWithStyles);
